var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":10,"offset":1}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('MODULE')],1)]),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('FIXMAN')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }